// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ProjectStatus,
} from "./types";

export default {
  projectId: __t.u32(),
  displayName: __t.option(__t.string()),
  description: __t.option(__t.string()),
  get status() {
    return __t.option(ProjectStatus);
  },
};
